
















































import { Component, Vue, Prop, Model, Ref } from 'vue-property-decorator';

import { MultiSelectValue } from './types'

import '@/assets/css/components/select-custom.scss'

import IconArrowDown from '@/components/icons/ArrowDown.vue';

@Component({
    components: {
        IconArrowDown,
    },
})
export default class MultiSelect extends Vue {
    @Model('change', { required: true }) readonly selected!: MultiSelectValue[]
    @Prop() readonly title!: string;
    @Prop() readonly items!: MultiSelectValue[]
    @Prop() readonly error!: string;
    @Prop() readonly disabled!: boolean;

    @Ref() readonly dropdownSelect!: HTMLDivElement

    isVisible = false;
    blockChangeVisible = false;
    stateClass = '';
    classOpen = 'open';

    search = '';

    get visible() {
        return this.isVisible;
    }

    set visible(visible: boolean) {
        if (this.blockChangeVisible) return;

        this.isVisible = visible;

        if (visible) {
            this.blockChangeVisible = true;
            setTimeout(() => {
                this.blockChangeVisible = false;
            }, 0);
        }
    }

    get filteredItems() {
        const normalizedSearch = this.search.toLowerCase();

        return this.items.filter(item => {
            const normalizedItem = item.value.toLowerCase();
            return normalizedItem.includes(normalizedSearch)
        });
    }

    // pop selected to the top
    get sortedItems() {
        const unselectedItems = this.filteredItems.filter(item => !this.checkIfSelected(item));

        return [
            ...this.selected,
            ...unselectedItems
        ]
    }

    get isLabelFloating() {
        return this.visible || this.search.length > 0 || this.selected.length > 0
    }

    get selectedPreview() {
        return this.selected.map(item => item.value).join(', ');
    }

    get selectedLookup() {
        const selectedIds = this.selected.map(item => item.id);

        return new Set(selectedIds);
    }

    checkIfSelected(item: MultiSelectValue) {
        return this.selectedLookup.has(item.id);
    }

    toggleItem(item: MultiSelectValue) {
        const isSelected = this.checkIfSelected(item);

        const items = isSelected ?
            this.selected.filter(selectedItem => selectedItem.id !== item.id) :
            [...this.selected, item];

        this.resetSearch();

        this.$emit('change', items);
    }

    mounted() {
        document.body.addEventListener('click', this.documentClick);
    }

    beforeDestroy() {
        document.body.addEventListener('click', this.documentClick);
    }

    documentClick(e: Event) {
        const el = this.dropdownSelect;
        const target = e.target as HTMLElement;

        if (this.visible) {
            if (el && el !== target && !el.contains(target)) {
                this.closeState();
            }
        }
    }

    closeState() {
        this.visible = false;
        this.stateClass = '';
    }

    toggleSelect() {
        if (this.disabled) {
            this.visible = false;
            this.stateClass == '';

            return;
        }

        this.visible = !this.visible;
        this.stateClass = this.stateClass === this.classOpen ? '' : this.classOpen;
    }

    resetSearch() {
        if (this.search) {
            this.search = '';
            this.$emit('search:reset');
        }
    }

    triggerSearch() {
        if (this.disabled) {
            return;
        }

        this.$emit('search', this.search);
    }

    selectedAll() {
        this.resetSearch();

        this.$emit('change', this.items);
    }
}
